var map = {
	"./animation-bonusslot-symbolMorphFX-spritesheet.png": 97248,
	"./bonusslot-potion-upcraft-displayglowback.png": 24270,
	"./bonusslot-potion-upcraftFlare-Spritesheet.png": 54526,
	"./meinekrone-frame-deko-full-sheet-32.png": 17967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99173;